/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reward_Incompleted_TitleInputs */

const en_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete all tasks to unlock rewards.`)
};

const ar_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل جميع المهام لفتح المكافآت.`)
};

const de_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfülle alle Aufgaben, um Belohnungen freizuschalten.`)
};

const es_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa todas las tareas para desbloquear recompensas.`)
};

const fr_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accomplissez toutes les tâches pour débloquer des récompenses.`)
};

const it_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa tutte le attività per sbloccare le ricompense.`)
};

const ja_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのタスクを完了して報酬を獲得しましょう。`)
};

const ko_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리워드를 개방하려면 모든 미션을 완료하세요.`)
};

const pt_br_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua todas as tarefas para desbloquear recompensas.`)
};

const ru_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполните все задания, чтобы разблокировать награды.`)
};

const th_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำงานทั้งหมดให้เสร็จสิ้นเพื่อปลดล็อกรางวัล`)
};

const tr_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödüllerin kilidini açmak için tüm görevleri tamamla.`)
};

const zh_cn_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成所有任务来解锁奖励`)
};

const zh_tw_reward_incompleted_title = /** @type {(inputs: Reward_Incompleted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成所有任務來解鎖獎勵`)
};

/**
* | output |
* | --- |
* | "Complete all tasks to unlock rewards." |
*
* @param {Reward_Incompleted_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const reward_incompleted_title = /** @type {((inputs?: Reward_Incompleted_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reward_Incompleted_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reward_incompleted_title(inputs)
	if (locale === "ar") return ar_reward_incompleted_title(inputs)
	if (locale === "de") return de_reward_incompleted_title(inputs)
	if (locale === "es") return es_reward_incompleted_title(inputs)
	if (locale === "fr") return fr_reward_incompleted_title(inputs)
	if (locale === "it") return it_reward_incompleted_title(inputs)
	if (locale === "ja") return ja_reward_incompleted_title(inputs)
	if (locale === "ko") return ko_reward_incompleted_title(inputs)
	if (locale === "pt_br") return pt_br_reward_incompleted_title(inputs)
	if (locale === "ru") return ru_reward_incompleted_title(inputs)
	if (locale === "th") return th_reward_incompleted_title(inputs)
	if (locale === "tr") return tr_reward_incompleted_title(inputs)
	if (locale === "zh_cn") return zh_cn_reward_incompleted_title(inputs)
	return zh_tw_reward_incompleted_title(inputs)
});